import { FunctionalComponent, h } from '@stencil/core';
import {AppMedia} from '../functional'

interface SectionGallery {
  __component: string;
  data?: any;
}


export const SectionGallery: FunctionalComponent<SectionGallery> = ({ data }) => {

  const {Title, Subtitle, Gallery} = data;
  const gallery = Gallery?.data || [];
  const heights = ['medium','large']

  return (
    <section class="uk-section">
      <div class="uk-container">
        <div hidden={!Title} class="uk-margin-bottom uk-padding uk-padding-remove-top uk-padding-remove-left">
          <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
          <h3 class="uk-heading-xlarge wsio-darker-green uk-width-1-1 uk-margin-remove">{Title}</h3>
        </div>
        <div class="uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid="masonry: true">
          {
          gallery.map((media, i) => 
            <div>
              <div class={`uk-cover-container uk-light uk-height-${heights[i % heights.length]}`}>
                <AppMedia media={media} size="(max-width: 638px) 80vw, (max-width: 958px) 80vw, 80vw" cover />
                <div hidden={!media.attributes.caption} class="uk-text-center uk-position-bottom uk-background-primary-trans uk-background-primary-trans-border">
                  <h4 class="uk-margin-top uk-margin-bottom uk-heading-small uk-button uk-button-link">{media.attributes.caption}</h4>
                </div>
              </div>
            </div>

          )
          }

        </div>
      </div>
    </section>)
};